import React, { useContext } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

export default observer(function LinkActiveEventsHOC(props: {
	eventId: string;
	className?: string;
	isLive?: boolean;
	children: JSX.Element | JSX.Element[];
}) {
	const myBetStore = useContext(MyBetsStoreContext);

	if (myBetStore?.activeEventsStore.eventsMap.has(props.eventId)) {
		const page = props.isLive ? DefaultPath.LIVE : "sports/full/event";
		const url = `/${getCurrentCulture()}/${page}/${props.eventId}`;

		return (
			<Link className={props.className} to={url}>
				{props.children}
			</Link>
		);
	}

	return <>{props.children}</>;
});
